import * as React from 'react';
import { DatePickerProps } from '@material-ui/pickers';
import { FormikProps } from 'formik';
import DayPicker from '../DayPicker/DayPicker';

type FormikDayPickerProps = Omit<DatePickerProps, 'onChange' | 'value'> & {
  valueId: string;
  formik: FormikProps<any>;
  defaultDay?: string;
  'data-test'?: string;
};

const FormikDayPicker: React.FC<FormikDayPickerProps> = (
  { formik, valueId, helperText, ...props },
) => {
  const { values, errors, handleChange, touched, handleBlur } = formik;
  const error = !!errors[valueId] && !!touched[valueId];

  const value = values[valueId];
  const handleChangePatch = (val: string) => handleChange({ target: { id: valueId, value: val } });

  return (
    <DayPicker
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      name={valueId}
      data-test={props['data-test'] || valueId}
      value={value}
      error={error}
      onChange={handleChangePatch}
      onBlur={handleBlur}
      helperText={error ? errors[valueId] : helperText}
    />
  );
};

export default FormikDayPicker;
